import React from 'react';
import { useAuth } from '@clerk/clerk-react';
import { Navigate } from 'react-router-dom';

const HomePage = () => {
    const { isSignedIn, isLoaded } = useAuth();
    if (!isLoaded) return null;
    return isSignedIn
        ? <Navigate to="/realtime" replace={true} />
        : <Navigate to="/login" replace={true} />;
};

export default HomePage;
